
import { Options, Vue } from 'vue-class-component';
import api from '@/shared/api';

const FAILED_PAYMENT_STATUSES = new Set(['failed', 'canceled', 'cancelled', 'expired']);

@Options({})
export default class CreditBundlePaymentCallback extends Vue {
    orderId = '';
    error = '';
    statusMessage = 'Confirming your payment…';

    async created() {
        this.orderId = (this.$route.query.orderId as string) || '';
        if (!this.orderId) {
            this.error = 'Missing order reference. Return to the credits page and try again.';
            return;
        }

        await this.waitForPaymentComplete();
    }

    async waitForPaymentComplete() {
        try {
            const status = await api.getCreditBundleOrderStatus(this.orderId);

            if (status.paymentStatus === 'paid') {
                this.statusMessage = 'Adding credits to your workspace…';
                await api.completeCreditBundlePayment(this.orderId);
                await this.$router.push({ name: 'credits' });
                return;
            }

            if (status.paymentStatus && FAILED_PAYMENT_STATUSES.has(status.paymentStatus)) {
                this.error = 'Payment was not completed. You can try again from the credits page.';
                return;
            }

            setTimeout(() => {
                this.waitForPaymentComplete();
            }, 1000);
        } catch (e: unknown) {
            const message = e instanceof Error ? e.message : 'Something went wrong while confirming payment.';
            this.error = message;
        }
    }
}
